import { Graph, Node } from '@antv/x6'
import { Flip, SvgStreamDataState } from "../services/modal"
import { useMemo, useState } from 'react'
import { Input } from 'antd'
import { SvgElem } from '@/components/SvgElem/SvgElem'
import classNames from 'classnames'
import { useUpdateEffect } from 'ahooks'
import { useCellStatusClassName } from '../plugins/UnitSimPlugin/CellsSimHooks'

const streamStr = `
 <svg viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg" style="overflow: visible">
    <path d="M0 25 H 150 V 0 L 200 50 L 150 100 V 75 H 0 z"
      style="fill:none;stroke:black;stroke-width:0.4mm;stroke-linejoin:round;vector-effect: non-scaling-stroke;" />
  </svg>
`

export const SvgStream = ({node}: {node: Node, graph: Graph}) => {
  const data: SvgStreamDataState = node.getData()
  const { streamTag: initTag, flip, streamId } = data
  const [text, setText] = useState(initTag);
  const [edit, setEdit] = useState(false);
  const angle = node.getAngle();
  const statusClass = useCellStatusClassName(streamId)

  const onChange = (e) => {
    setText(e.target.value)
  }

  const onSave = () => {
    const newData = node.getData()
    node.setData({...newData, streamTag: text})
    setEdit(false)
  }

  const flipClassName = useMemo(() => {
    if (flip === Flip.X) return 'node-flip-x';
    if (flip === Flip.Y) return 'node-flip-y';
    return ''
  }, [flip])

  useUpdateEffect(() => {
    const port: any = node.getPorts()[0]
    if (flip === Flip.X) {
      node.portProp(port.id, 'args/y', 1 - port.layout!.y || 0)
      node.portProp(port.id, 'args/x', port.layout!.x || 0)
    } else if (flip === Flip.Y) {
      node.portProp(port.id, 'args/x', 1 - port.layout!.x || 0)
      node.portProp(port.id, 'args/y', port.layout!.y || 0)
    } else {
      node.portProp(port.id, 'args/y', port.layout!.y || 0)
      node.portProp(port.id, 'args/x', port.layout!.x || 0)
    }
  }, [flip, node])


  const textStyle: any = {
    transform: `rotate(${-angle}deg)`,
  }
  if (Math.abs(angle) === 180) {
    textStyle.justifyContent = 'end'
  }

  return <div className={classNames('fs-node', statusClass)}>
    <SvgElem className={classNames('fs-svg-node', flipClassName)} imageStr={streamStr} />
    {/* <img src={svgStrToDataUrl(imageElem)} style={{ width: '100%', height: '100%' }} key={node.id} /> */}
    <div className='svg-stream-container'>
      {!edit && <div style={{ width: '100%', height: '100%', ...textStyle }} className='flex-col-center pl-1 pr-1' onDoubleClick={() => setEdit(true)}>{text}</div>}
      {edit && <div style={{ width: '100%', height: '100%', ...textStyle }} className='flex-center'>
        <Input
          style={{ width: '100%'}}
          value={text}
          autoFocus={true}
          onBlur={onSave}
          onChange={onChange} />
        </div>}
    </div>
  </div>
}

export enum SvgStreamDirection {
  In,
  Out,
}